// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"f41c540b","541":"cc52065c","545":"46de368c","787":"5fd1411d"}[chunkId] + ".chunk.js";
};